/*
  © 2025 LuminTheme
  https://www.lumintheme.com
*/

class LuminShoppableVideos extends HTMLElement {
  connectedCallback() {
    if (this.dataset.videoControlsInitialized === "true") return;

    this.dataset.videoControlsInitialized = "true";

    this.querySelectorAll("video").forEach((video) => {
      video.addEventListener("click", () => {
        this.onVideoPlay(video);
      });

      ["play", "pause", "ended"].forEach((eventName) => {
        video.addEventListener(eventName, () => {
          this.syncVideoState(video);
        });
      });

      this.syncVideoState(video);

      if (video.dataset.autoplay === "true") {
        video.muted = true;
        this.playVideo(video);
      }
    });

    this.querySelectorAll(".lm-video-toggle").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const cardInner = button.closest(".card__inner");
        const video = cardInner?.querySelector("video");

        if (!video) return;

        this.onVideoPlay(video);
      });
    });

    this.querySelectorAll("a[data-quick-view]").forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        this.openQuickView(link);
      });
    });
  }

  syncVideoState(video) {
    const isPlaying = !video.paused && !video.ended;
    const card = video.closest(".card");
    const cardInner = video.closest(".card__inner");
    const button = cardInner?.querySelector(".lm-video-toggle");

    card?.setAttribute("data-playing", String(isPlaying));

    if (!button) return;

    button.classList.toggle("is-playing", isPlaying);
    button.setAttribute("aria-label", isPlaying ? "Video pausieren" : "Video abspielen");
    button.setAttribute("aria-pressed", String(isPlaying));
  }

  onVideoPlay(video) {
    if (!video.paused && !video.ended) {
      video.pause();
      return;
    }

    this.playVideo(video);
  }

  playVideo(video) {
    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {
        this.syncVideoState(video);
      });
    }
  }

  async openQuickView(link) {
    link.disabled = true;
    link.setAttribute("aria-busy", "true");
    link.querySelector(".icon-wrapper").setAttribute("hidden", "hidden");
    link.querySelector(".spinner-border").removeAttribute("hidden");

    const response = await fetch(link.dataset.productUrl + ".js");

    if (response.ok) {
      const data = await response.json();
      console.log(data);

      document.querySelector("product-quick-view-modal").showModal(data);
    }

    link.disabled = false;
    link.removeAttribute("aria-busy");
    link.querySelector(".icon-wrapper").removeAttribute("hidden");
    link.querySelector(".spinner-border").setAttribute("hidden", "hidden");
  }
}

customElements.define("lumin-shoppable-videos", LuminShoppableVideos);
